/* brain-design-factory-main-v10.0 */
(function () {
  var root = document.querySelector('[data-df-main-page]');
  if (root && root.getAttribute('data-df-phase') !== '10') {
    var host = root.closest('[id^="shopify-section-template-"]');
    if (host) {
      var sectionId = host.id.replace('shopify-section-', '');
      fetch(location.pathname + '?sections=' + encodeURIComponent(sectionId) + '&_df=' + Date.now() + '&variant=' + Date.now(), { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (payload) {
          if (!payload || !payload[sectionId]) return;
          var wrap = document.createElement('div');
          wrap.innerHTML = payload[sectionId];
          var fresh = wrap.firstElementChild;
          if (fresh) host.replaceWith(fresh);
        })
        .catch(function () {});
    }
  }

  root = document.querySelector('[data-df-main-page]');
  if (!root) return;

  var API_BASE = root.getAttribute('data-df-api-base') || '/apps/design-factory';
  var sessionId = '';
  var selectedWorld = null;
  var productImages = {};
  var worldProducts = {};
  var variants = [{"id":"chest-small","title":"Dezentes Brustlogo","subtitle":"Klar und zurückhaltend"},{"id":"chest-back","title":"Brust & Rücken","subtitle":"Sichtbar im Team"},{"id":"team","title":"Teamkollektion","subtitle":"Einheitlicher Auftritt"},{"id":"mono","title":"Monochrom","subtitle":"Reduziert und stark"},{"id":"color","title":"Farblich abgestimmt","subtitle":"Passend zur Berufswelt"}];

  try {
    var imgEl = document.getElementById('df-product-images');
    if (imgEl) productImages = JSON.parse(imgEl.textContent || '{}');
    var wpEl = document.getElementById('df-world-products');
    if (wpEl) worldProducts = JSON.parse(wpEl.textContent || '{}');
  } catch (e) {}

  function apiUrl(path) { return API_BASE + path; }
  function qs(sel) { return root.querySelector(sel); }
  function qsa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function setText(sel, v) { var el = qs(sel); if (el) el.textContent = v; }

  function readWorldFromBtn(btn) {
    var id = btn.getAttribute('data-df-world-id');
    if (!id) return null;
    var title = btn.querySelector('.df-world-card__title');
    var sub = btn.querySelector('.df-world-card__sub');
    var textEl = btn.querySelector('.df-world-card__meta');
    return {
      id: id,
      title: title ? title.textContent : id,
      subtitle: sub ? sub.textContent : '',
      collectionTitle: (title ? title.textContent : '') + ' · StrongAnt Kollektion',
      collectionText: sub ? sub.textContent : '',
      productIds: worldProducts[id] || [],
      productPreviews: (worldProducts[id] || []).map(function (pid) {
        return { id: pid, label: ({'t-shirt':'T-Shirt',sweatshirt:'Sweatshirt',hoodie:'Hoodie',cap:'Cap',beanie:'Beanie'})[pid] || pid, imageUrl: productImages[pid] || '' };
      }),
    };
  }

  function showJourney(show) { var p = qs('[data-df-journey]'); if (p) p.hidden = !show; }
  function showPanel(name) { qsa('[data-df-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-df-panel') !== name; }); }
  function scrollToEl(sel) { var el = qs(sel); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  function setStep(step) {
    qsa('[data-df-step]').forEach(function (el) {
      var n = Number(el.getAttribute('data-df-step'));
      el.classList.toggle('is-active', n === step);
      el.classList.toggle('is-done', n < step);
    });
    var labels = {1:'Berufswelt',2:'Kollektion',3:'Design',4:'Vorschläge',5:'Freigabe',6:'Warenkorb'};
    setText('[data-df-progress-current]', 'Schritt ' + step + ' · ' + (labels[step] || ''));
  }

  function renderWorldSelection() {
    qsa('[data-df-world-btn]').forEach(function (btn) {
      var on = selectedWorld && btn.getAttribute('data-df-world-id') === selectedWorld.id;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-selected', on);
    });
  }

  function renderCollection(world) {
    setText('[data-df-world-label]', world.title);
    setText('[data-df-collection-text]', world.collectionText || world.subtitle);
    var grid = qs('[data-df-product-grid]');
    if (!grid) return;
    grid.innerHTML = (world.productPreviews || []).map(function (item) {
      return '<button type="button" class="df-product-card is-selected" data-df-product-card data-df-product-id="' + item.id + '" aria-pressed="true">' +
        '<span class="df-product-card__media">' + (item.imageUrl ? '<img src="' + item.imageUrl + '" alt="' + item.label + '">' : '') + '</span>' +
        '<span class="df-product-card__name">' + item.label + '</span></button>';
    }).join('');
    qsa('[data-df-product-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        var on = card.getAttribute('aria-pressed') === 'true';
        card.setAttribute('aria-pressed', on ? 'false' : 'true');
        card.classList.toggle('is-selected', !on);
      });
    });
  }

  function selectedProductIds() {
    return qsa('[data-df-product-card][aria-pressed="true"]').map(function (el) { return el.getAttribute('data-df-product-id'); });
  }

  function renderVariants() {
    var grid = qs('[data-df-variant-grid]');
    if (!grid) return;
    var sample = ((selectedWorld && selectedWorld.productPreviews) || []).find(function (p) { return p.imageUrl; });
    grid.innerHTML = variants.map(function (v) {
      return '<button type="button" class="df-variant-card" data-df-variant-id="' + v.id + '">' +
        '<span class="df-variant-card__media">' + (sample && sample.imageUrl ? '<img src="' + sample.imageUrl + '" alt="">' : '') + '</span>' +
        '<span><strong>' + v.title + '</strong><br><span style="color:var(--df-muted);font-size:13px">' + v.subtitle + '</span></span></button>';
    }).join('');
  }

  function renderPreviews(previews, title, targetSel) {
    var grid = qs(targetSel || '[data-df-preview-grid]');
    if (!grid) return;
    grid.innerHTML = (previews || []).map(function (item) {
      return '<article class="df-preview-card"><div class="df-preview-card__media">' +
        (item.imageUrl ? '<img src="' + item.imageUrl + '" alt="' + item.title + '">' : '') +
        '</div><p class="df-preview-card__title">' + item.title + (title ? ' · ' + title : '') + '</p></article>';
    }).join('');
  }

  function localPreviews(variantId) {
    var ids = selectedProductIds();
    var variant = variants.find(function (v) { return v.id === variantId; }) || variants[2];
    return ids.map(function (id) {
      return { productId: id, title: ({'t-shirt':'T-Shirt',sweatshirt:'Sweatshirt',hoodie:'Hoodie',cap:'Cap',beanie:'Beanie'})[id] || id, imageUrl: productImages[id] || '', shopifyUrl: '', buyable: false, variantTitle: variant.title };
    });
  }

  function fetchApi(path, options) {
    return fetch(apiUrl(path), Object.assign({ credentials: 'same-origin' }, options || {}))
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  function startWorld(worldId, entryPath) {
    var btn = qsa('[data-df-world-btn]').find(function (b) { return b.getAttribute('data-df-world-id') === worldId; });
    selectedWorld = btn ? readWorldFromBtn(btn) : null;
    if (!selectedWorld) return Promise.reject(new Error('Berufswelt nicht gefunden'));
    renderWorldSelection();
    renderCollection(selectedWorld);
    showJourney(true);
    showPanel('collection');
    setStep(2);
    scrollToEl('[data-df-journey]');
    return fetchApi('/sessions', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ worldId: worldId }) })
      .then(function (payload) {
        if (payload && payload.success) {
          sessionId = payload.data.session.id;
          try { sessionStorage.setItem('df-session-id', sessionId); } catch (e) {}
          if (entryPath) return chooseEntry(entryPath, true);
        }
      });
  }

  function saveProducts() {
    showPanel('entry');
    setStep(3);
    if (!sessionId) return Promise.resolve();
    return fetchApi('/sessions/' + encodeURIComponent(sessionId), {
      method: 'PATCH', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ selectedProductIds: selectedProductIds() }),
    });
  }

  function chooseEntry(path, skipPanel) {
    if (!skipPanel) { if (path === 'design') { showPanel('variants'); setStep(4); renderVariants(); } else { showPanel('upload'); setStep(3); } }
    if (!sessionId) return Promise.resolve();
    return fetchApi('/sessions/' + encodeURIComponent(sessionId), {
      method: 'PATCH', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ entryPath: path, selectedProductIds: selectedProductIds() }),
    }).then(function () {
      if (path === 'design') { showPanel('variants'); setStep(4); renderVariants(); }
      else { showPanel('upload'); setStep(3); }
    });
  }

  function uploadLogo(file) {
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function (ev) {
      var url = String(ev.target && ev.target.result || '');
      var sample = productImages.hoodie || productImages['t-shirt'] || '';
      var pipe = qs('[data-df-pipeline]');
      if (pipe) {
        pipe.hidden = false;
        pipe.innerHTML = '<div class="df-pipeline-step"><div class="df-pipeline-step__media"><img src="' + url + '"></div><span class="df-pipeline-step__label">Hochgeladen</span></div>' +
          '<div class="df-pipeline-step"><div class="df-pipeline-step__media"><img src="' + url + '"></div><span class="df-pipeline-step__label">Erkannt</span></div>' +
          '<div class="df-pipeline-step"><div class="df-pipeline-step__media"><img src="' + url + '"></div><span class="df-pipeline-step__label">Bereinigt</span></div>' +
          '<div class="df-pipeline-step"><div class="df-pipeline-step__media"><img src="' + sample + '"></div><span class="df-pipeline-step__label">Auf Produkt</span></div>';
      }
    };
    reader.readAsDataURL(file);
    if (!sessionId) { showPanel('variants'); setStep(4); renderVariants(); return; }
    var body = new FormData();
    body.append('file', file);
    body.append('inputKind', 'logo_file');
    fetch(apiUrl('/sessions/' + encodeURIComponent(sessionId) + '/upload'), { method: 'POST', body: body, credentials: 'same-origin' })
      .finally(function () { showPanel('variants'); setStep(4); renderVariants(); });
  }

  function selectVariant(variantId) {
    qsa('[data-df-variant-id]').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-df-variant-id') === variantId);
    });
    var variant = variants.find(function (v) { return v.id === variantId; });
    var previews = localPreviews(variantId);
    if (sessionId) {
      fetchApi('/sessions/' + encodeURIComponent(sessionId) + '?action=variant', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ variantId: variantId }),
      }).then(function (payload) {
        if (payload && payload.success) previews = payload.data.session.previews;
        renderPreviews(previews, variant ? variant.title : '');
        showPanel('review');
        setStep(5);
      });
    } else {
      renderPreviews(previews, variant ? variant.title : '');
      showPanel('review');
      setStep(5);
    }
  }

  function approveDesign() {
    var rights = qs('[data-df-rights]');
    if (!rights || !rights.checked) { setText('[data-df-approve-hint]', 'Bitte Rechte bestätigen.'); return; }
    var previews = localPreviews();
    if (sessionId) {
      fetchApi('/sessions/' + encodeURIComponent(sessionId) + '?action=approve', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ rightsConfirmed: true }),
      }).then(function (payload) {
        if (payload && payload.success) previews = payload.data.session.previews;
        renderPreviews(previews, '', '[data-df-checkout-grid]');
        showPanel('checkout');
        setStep(6);
      });
    } else {
      renderPreviews(previews, '', '[data-df-checkout-grid]');
      showPanel('checkout');
      setStep(6);
    }
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var worldBtn = t.closest('[data-df-world-btn]');
    if (worldBtn) { startWorld(worldBtn.getAttribute('data-df-world-id')).catch(function (err) { setText('[data-df-hint]', err.message); }); return; }
    if (t.closest('[data-df-action="collection-continue"]')) { saveProducts(); return; }
    if (t.closest('[data-df-entry="design"]')) { chooseEntry('design'); return; }
    if (t.closest('[data-df-entry="logo"]')) { chooseEntry('logo'); return; }
    if (t.closest('[data-df-variant-id]')) { selectVariant(t.closest('[data-df-variant-id]').getAttribute('data-df-variant-id')); return; }
    if (t.closest('[data-df-action="approve"]')) { approveDesign(); return; }
    var scroll = t.closest('[data-df-scroll]');
    if (scroll) { e.preventDefault(); scrollToEl(scroll.getAttribute('data-df-scroll')); return; }
    var start = t.closest('[data-df-start]');
    if (start) {
      var mode = start.getAttribute('data-df-start');
      scrollToEl('#df-welten');
      if (mode === 'logo') startWorld('construction', 'logo');
      else if (mode === 'design') startWorld('agriculture', 'design');
    }
  });

  var drop = qs('[data-df-dropzone]');
  var input = qs('[data-df-logo-input]');
  if (drop && input) {
    drop.addEventListener('click', function () { input.click(); });
    drop.addEventListener('dragover', function (ev) { ev.preventDefault(); });
    drop.addEventListener('drop', function (ev) { ev.preventDefault(); var f = ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0]; if (f) uploadLogo(f); });
    input.addEventListener('change', function () { var f = input.files && input.files[0]; if (f) uploadLogo(f); });
  }

  renderWorldSelection();

  var worldScroll = root.querySelector('[data-df-world-scroll]');
  var worldPrev = root.querySelector('[data-df-world-prev]');
  var worldNext = root.querySelector('[data-df-world-next]');
  if (worldScroll && worldPrev && worldNext) {
    var step = function () {
      var card = worldScroll.querySelector('.df-world-card');
      return card ? card.getBoundingClientRect().width + 18 : 400;
    };
    worldPrev.addEventListener('click', function () { worldScroll.scrollLeft -= step(); });
    worldNext.addEventListener('click', function () { worldScroll.scrollLeft += step(); });
  }
})();
